import { Component, OnInit } from '@angular/core';
import {FormGroup, FormControl, Validators} from '@angular/forms';
import { SubscribeService } from '../footer/subscribe.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  myReactiveForm:FormGroup

  constructor(private _service: SubscribeService) { }

  ngOnInit() {
    this.myReactiveForm = new FormGroup({
      'email':new FormControl(null, [Validators.required, Validators.email]),
    })
  }

  getRoute(endpoint: string) {
    // const lang = localStorage.getItem('LOCAL_DEFAULT_LANGUAGE');
    return '/' + endpoint;
  }

  onSubmit() {
    if (this.myReactiveForm.invalid) {
      return;
    } else {
      this._service.Subscribe(this.myReactiveForm.value);
    }
    this.myReactiveForm.reset({
      'email': '',
  });

}

}
